// extracted by css-extract-rspack-plugin
export default {"projectsList":"projectsList-FK5ijX"};